
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[businessUnit]",
      function () {
        return require("private-next-pages/[businessUnit]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[businessUnit]"])
      });
    }
  